import React, { Component } from 'react';
import Graph from './evolutionGraphModal';
import GraphTwo from './evolutionGraphModalTwo';

const Modal = props => (
  <div
    data-close="ok"
    onClick={props.handleModal}
    className={props.modal ? `container-modal` : `container-modal hide`}
  >
    <div className={props.modalRight ? `box-modal start` : `box-modal`}>
      <a>
        <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
      </a>
      <div className="container-driver-title">
        <h2>{props.language.detail_waiting_times.fufillment.mainIndicator}</h2>
      </div>
      <div className="container-driver-modal">
        <div className="box-driver-modal--one">
          <Graph data={props.data} />
          <GraphTwo
            data={[
              { date: 1530662400000, percentage: 20 },
              { date: 1530748800000, percentage: 24 },
              { date: 1530835200000, percentage: 32 },
              { date: 1530921600000, percentage: 31 },
              { date: 1531008000000, percentage: 20 }
            ]}
          />
        </div>
        <div className="box-driver-modal--two">
          <h3>20</h3>
          <p>{props.language.detail_waiting_times.fufillment.homework}</p>
          <div className="modal-simbologia">
            <span className="one">% {props.language.detail_waiting_times.fufillment.manage}</span>
            <span className="two">
              % {props.language.detail_waiting_times.fufillment.fulfillment}
            </span>
          </div>
        </div>
        <div className="box-driver-modal--three">
          <ul className="container-driver-table-ul">
            <li className="container-driver-table-li">
              <strong>{props.language.detail_waiting_times.fufillment.homework}:</strong>
              {props.language.detail_waiting_times.fufillment._break}
              <ul>
                <li>Test</li>
                <li>Test</li>
              </ul>
            </li>
          </ul>
          <ul className="container-driver-table-ul">
            <li className="container-driver-table-li">
              <strong>{props.language.detail_waiting_times.fufillment.driver}:</strong>
              {props.language.detail_waiting_times.fufillment._break}
              <ul>
                <li>Test</li>
                <li>Test</li>
              </ul>
            </li>
          </ul>
          <ul className="container-driver-table-ul">
            <li className="container-driver-table-li">
              <strong>{props.language.detail_waiting_times.fufillment.type}:</strong>
              {props.language.detail_waiting_times.fufillment._break}
              <ul>
                <li>Test</li>
                <li>Test</li>
              </ul>
            </li>
          </ul>
          <ul className="container-driver-table-ul">
            <li className="container-driver-table-li">
              <strong>{props.language.detail_waiting_times.fufillment.state}:</strong>
              {props.language.detail_waiting_times.fufillment.open}
              <ul>
                <li>Test</li>
                <li>Test</li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="box-driver-modal--four">
          <table>
            <thead>
              <tr>
                <th>{props.language.detail_waiting_times.fufillment.date}</th>
                <th>{props.language.detail_waiting_times.fufillment.homework}</th>
                <th>{props.language.detail_waiting_times.fufillment.driver}</th>
                <th>{props.language.detail_waiting_times.fufillment.type}</th>
                <th>{props.language.detail_waiting_times.fufillment.state}</th>
              </tr>
            </thead>
            <tbody>
              <tr onClick={props.handleModalRight}>
                <td>27/06</td>
                <td>Descanso bajo 8 horas</td>
                <td>Juan David Castro</td>
                <td>Gestión</td>
                <td className="green">Abierta</td>
              </tr>
              <tr>
                <td>27/06</td>
                <td>Descanso bajo 8 horas</td>
                <td>Juan David Castro</td>
                <td>Gestión</td>
                <td className="green">Abierta</td>
              </tr>
              <tr>
                <td>27/06</td>
                <td>Descanso bajo 8 horas</td>
                <td>Juan David Castro</td>
                <td>Gestión</td>
                <td className="green">Abierta</td>
              </tr>
              <tr>
                <td>27/06</td>
                <td>Descanso bajo 8 horas</td>
                <td>Juan David Castro</td>
                <td>Gestión</td>
                <td className="green">Abierta</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default Modal;



// WEBPACK FOOTER //
// ./source/client/components/driver_fulfillment/modal.jsx